// src/components/admin/AddTeamPopover.tsx
import React, { useState } from "react";
import {
  Popover,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import type { AdminTeam } from "../../hooks/useAdminData";

interface AddTeamPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  teams: AdminTeam[];
  assignedTeamIds: number[];
  onSelect: (teamId: number) => void;
}

const AddTeamPopover: React.FC<AddTeamPopoverProps> = ({
  anchorEl,
  onClose,
  teams,
  assignedTeamIds,
  onSelect,
}) => {
  const [search, setSearch] = useState("");

  const available = teams.filter(
    (t) =>
      !assignedTeamIds.includes(t.id) &&
      t.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      slotProps={{ paper: { sx: { width: 260, maxHeight: 320 } } }}
    >
      <Box sx={{ p: 1 }}>
        <TextField
          size="small"
          placeholder="Search teams..."
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 1 }}
        />
      </Box>
      {available.length === 0 ? (
        <Typography sx={{ p: 2, color: "#9CA3AF", fontSize: "0.85rem", textAlign: "center" }}>
          No teams available
        </Typography>
      ) : (
        <List dense sx={{ maxHeight: 220, overflow: "auto" }}>
          {available.map((team) => (
            <ListItemButton
              key={team.id}
              onClick={() => {
                onSelect(team.id);
                onClose();
              }}
            >
              <ListItemText
                primary={team.name}
                secondary={`${team.member_count} members`}
                primaryTypographyProps={{ fontSize: "0.85rem" }}
                secondaryTypographyProps={{ fontSize: "0.75rem" }}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </Popover>
  );
};

export default AddTeamPopover;
